import { Phone, MessageSquareText } from "lucide-react";
import { useQuote } from "@/context/QuoteContext";
import { SITE } from "@/data/site";

export const StickyCTA = () => {
  const { openQuote } = useQuote();
  return (
    <div data-testid="sticky-mobile-cta" className="lg:hidden fixed bottom-0 inset-x-0 z-40 grid grid-cols-2 gap-px bg-slate-200 border-t border-slate-200 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]">
      <a
        href={SITE.phoneHref}
        data-testid="sticky-call-btn"
        className="flex items-center justify-center gap-2 bg-slate-900 text-white font-bold py-3.5 active:bg-slate-800"
      >
        <Phone className="h-5 w-5" /> Call Now
      </a>
      <button
        onClick={() => openQuote()}
        data-testid="sticky-quote-btn"
        className="flex items-center justify-center gap-2 bg-red-700 text-white font-bold py-3.5 active:bg-red-800"
      >
        <MessageSquareText className="h-5 w-5" /> Free Quote
      </button>
    </div>
  );
};
